import React, {useRef } from 'react';
import Slider from "react-slick";
import nextArrow from "../../img/next.png"
import prevArrow from "../../img/prev.png"

function SampleNextArrow(props) {
    const { className, style, onClick } = props;
    return (
        <div
            className="absolute w-[40px] h-[100px] z-30 top-[calc(50%-50px)] bottom-0 right-3.5 text-white bg-[#ff8048]/50 hover:bg-[#ff8048] bg-contain bg-no-repeat p-3"
            style={{ ...style, display: "block", backgroundImage: `url(${nextArrow})`, backgroundSize: "30px",backgroundPosition: "center" }}
            onClick={onClick}
        />
    );
}

function SamplePrevArrow(props) {
    const { className, style, onClick } = props;
    return (
        <div
            className="absolute w-[40px] h-[100px] z-30 top-[calc(50%-50px)] bottom-0 left-3.5 text-white bg-[#ff8048]/50 hover:bg-[#ff8048] bg-contain bg-no-repeat p-3"
            style={{ ...style, display: "block", backgroundImage: `url(${prevArrow})`, backgroundSize: "30px",backgroundPosition: "center" }}
            onClick={onClick}
        />
    );
}

function CustomGallery({myGallery}) {

    const settings = {
        centerMode: true,
        infinite: true,
        centerPadding: "200px",
        slidesToShow: 1,
        speed: 500,
        nextArrow: <SampleNextArrow />,
        prevArrow: <SamplePrevArrow />,
        markers: true
    };

    const settingsMobile = {
        infinite: true,
        slidesToShow: 1,
        speed: 500,
        nextArrow: <SampleNextArrow />,
        prevArrow: <SamplePrevArrow />,
        markers: true
    };

    let sliderRef = useRef(null);

    return (
        myGallery ?
            <section className="relative py-0 overflow-hidden z-20 bg-black">
                <div className="sm:block hidden" id="gallery">
                    {/*<div className="container mx-auto text-center pb-10 ">*/}
                    {/*    <h2 className="text-4xl uppercase">{myGallery.gallery_title}</h2>*/}
                    {/*</div>*/}
                    <div>
                        <Slider {...settings}>
                            {
                                myGallery.gallery_item.map((item, index) => (

                                    <div key={index}>
                                        <img src={item} className="w-full"/>
                                    </div>

                                ))
                            }
                        </Slider>
                    </div>
                </div>
                <div className="sm:hidden block" id="gallery">
                    {/*<div className="container mx-auto text-center pb-10 ">*/}
                    {/*    <h2 className="text-4xl uppercase">{myGallery.gallery_title}</h2>*/}
                    {/*</div>*/}
                    <div>
                        <Slider {...settingsMobile}>
                            {
                                myGallery.gallery_item.map((item, index) => (

                                    <div key={index}>
                                        <img src={item} className="w-full"/>
                                    </div>

                                ))
                            }
                        </Slider>
                    </div>
                </div>

            </section> : ''
    )

}

export default CustomGallery;
